"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniProviderCardPageList = exports.MiniProviderPageList = void 0;
var MiniProviderPageList_1 = require("./MiniProviderPageList");
Object.defineProperty(exports, "MiniProviderPageList", { enumerable: true, get: function () { return __importDefault(MiniProviderPageList_1).default; } });
var MiniProviderCardPageList_1 = require("./MiniProviderCardPageList");
Object.defineProperty(exports, "MiniProviderCardPageList", { enumerable: true, get: function () { return __importDefault(MiniProviderCardPageList_1).default; } });
//# sourceMappingURL=index.js.map